import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { useTranslation } from "react-i18next";

const filterD1PdfPageSelectionSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_view_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterD1PdfPageSelectionSchema = z.infer<
  typeof filterD1PdfPageSelectionSchema
>;

export function D1PdfPageSelectionFilter() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: "client_contains",
      label: t("d1_pdf_page_selection.searchbox.client_contains", { defaultValue: "Client" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.D1}/${Tables.D1_PDF_PAGE_SELECTION}`,
      column_name: "client",
    },
    {
      name: "page_name_contains",
      label: t("d1_pdf_page_selection.searchbox.page_name_contains", { defaultValue: "Page name" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.D1}/${Tables.D1_PDF_PAGE_SELECTION}`,
      column_name: "page_name",
    },
    {
      name: "tableau_view_contains",
      label: t("d1_pdf_page_selection.searchbox.tableau_view_contains", { defaultValue: "Tableau view" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.D1}/${Tables.D1_PDF_PAGE_SELECTION}`,
      column_name: "tableau_view",
    },
    {
      name: "tableau_workbook_id_contains",
      label: t("d1_pdf_page_selection.searchbox.tableau_workbook_id_contains", { defaultValue: "Tableau workbook ID" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.D1}/${Tables.D1_PDF_PAGE_SELECTION}`,
      column_name: "tableau_workbook_id",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t("d1_pdf_page_selection.searchbox.created_at", { defaultValue: "Creation date" }),
      from: { name: "created_at_from" },
      to: { name: "created_at_to" },
    },
  ];
  return (
    <FilterTable
      client={Clients.D1}
      schema={filterD1PdfPageSelectionSchema}
      tableName={Tables.D1_PDF_PAGE_SELECTION}
      fields={fields}
    />
  );
}
